const SessionWarningMode = {
  Expired: -1,
  NoWarning: 0,
  WillExpire: 1
};

export default SessionWarningMode;